module.exports = __webpack_public_path__ + "img/kerry.02db2a75.png";